export const COMPONENT_NAME = 'SingleSlideCarousel';
